import { render, staticRenderFns } from "./StorageTakeoutTab.vue?vue&type=template&id=47e25ee2&"
import script from "./StorageTakeoutTab.vue?vue&type=script&lang=js&"
export * from "./StorageTakeoutTab.vue?vue&type=script&lang=js&"
import style0 from "./StorageTakeoutTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports